import React from 'react'

function Toggle({ handleChange, isChecked, showLabel = true }) {
    return (
        <div className='toggle-container'>
            <input
                type='checkbox'
                id='darkmode-toggle'
                className='toggle'
                onChange={handleChange}
                checked={isChecked}
            />
            {showLabel && (
                <label htmlFor='darkmode-toggle'>
                    {isChecked ? 'Light Mode' : 'Dark Mode'}
                </label>
            )}

        </div>
    )
}

export default Toggle
